<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">

      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="子站简称">
              <a-input placeholder="请输入" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="状态">
              <a-select v-model="where.keyword.status" placeholder="请选择" allowClear>
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">已启用</a-select-option>
                <a-select-option value="0">已禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'子站管理-搜索'">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo()" type="primary" v-btnlimit="'子站管理-添加'"/>
      <pxkeji-btn name="批量启用" v-if="selectRows.length>0" @click="changeStatusBatch(1)" class="pxkeji_basic_btn" v-btnlimit="'子站管理-批量启用'" />
      <pxkeji-btn name="批量禁用" v-if="selectRows.length>0" @click="changeStatusBatch(0)" class="pxkeji_basic_btn" v-btnlimit="'子站管理-批量禁用'" />
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==1" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="编辑" size="small" @click="showInfo(info.id)" type="primary" v-btnlimit="'子站管理-编辑'" />
          <a-divider type="vertical" />
              <pxkeji-btn name="资源授权" size="small" @click="showInitData(info.id,info.adminTel)" type="primary" v-btnlimit="'子站管理-资源授权'"/>
          <a-divider type="vertical" />
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="2">
                <pxkeji-btn
                  name="禁用"
                  v-if="info.status==1"
                  v-btnlimit="'子站管理-启用禁用'"
                  @click="changeStatus(info.id,0)"
                  size="small"
                  type="default"
                />
                <pxkeji-btn
                  name="启用"
                  v-else
                  size="small"
                  v-btnlimit="'子站管理-启用禁用'"
                  @click="changeStatus(info.id,1)"
                  type="default"
                />
              </a-menu-item>
              <a-menu-item key="3">
                <pxkeji-btn name="删除" size="small" type="default" @click="delInfo(info.id)" v-btnlimit="'子站管理-删除'" />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'子站管理-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" />
    </a-modal>
    <a-modal
            :title="dataChoose.title"
            v-model="dataChoose.visible"
            width="80%"
            :footer="false"
            destroyOnClose
            :maskClosable="false"
    >
      <initData @callbackMethod="save" :id="dataChoose.id" :adminTel="dataChoose.adminTel" />
    </a-modal>

  </div>
</template>
<script>
var that;
import Info from "./areaInfo.vue"; // 编辑
import initData from "./initDataList.vue";//关联资料

const columns = [
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "子站简称"
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "管理员"
  },
  {
    dataIndex: "domain",
    key: "domain",
    align: "center",
    title: "域名",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "创建时间"
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "areaList",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          status: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      dataChoose: {
        visible: false,
        id: 0,
        title: "资源授权",
        type: 0,
        adminTel:"",
      },

      addedit: {
        //编辑
        visible: false,
        id: 0,
        title: "",
        type: 0
      },
      visibleSupply: false //弹框
    };
  },
  components: {
    Info: Info,
    initData:initData
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    saveData(){
      this.dataChoose.visible=false;
    },
    showInitData(id,tel){
      this.dataChoose.id=id;
      this.dataChoose.adminTel=tel;
      this.dataChoose.visible=true;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.area
        .getAreaInfoPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.name,
          this.where.keyword.status
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },

    //查看订单
    showInfo(id) {
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.title = "基本信息";
    },
    changeStatusBatch(status) {
      this.$confirm({
        title:
          "您确定要执行批量" + (status == 1 ? "启用" : "禁用") + "的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.changeStatus(that.selectRows.join(","), status);
        },
        onCancel() {}
      });
    },
    changeStatus(id, status) {
      this.isloading = true;
      this.$api.area
        .updateStatus(id, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.area
            .deleteById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },

    //子组件传值
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

